import {
  Component,
  OnInit,
  Input,
  Output,
  OnChanges,
  EventEmitter,
  SimpleChanges,
} from '@angular/core'
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete'
import { ProjectService } from '../../../services/project.service'
import { SnackbarService } from '../../../services/snackbar.service'
import { IProject, IProjectItem } from '../../../models/project.model'
import { UntypedFormControl } from '@angular/forms'
import { Observable } from 'rxjs'
import { startWith, map } from 'rxjs/operators'
import { Router } from '@angular/router'
import { TranslateService } from '@ngx-translate/core'

export interface Product {
  product_id: number
  quantity: number
}

@Component({
  selector: 'app-add-project-item',
  templateUrl: './add-project-item.component.html',
  styleUrls: ['./add-project-item.component.scss'],
})
export class AddProjectItemComponent implements OnInit, OnChanges {
  @Input() productItem: any = {}
  @Input() projects: IProject[]
  @Input() hasHoverEffect = false
  @Input() open = false
  @Input() buttonClicked = false
  @Output() openChange = new EventEmitter<boolean>()

  defaultItem = { id: -1, name: '' }
  options: IProject[] = []
  projectName: any
  selectedProject: any

  selectedProduct: Product

  myControl = new UntypedFormControl()
  filteredOptions: Observable<IProject[]>
  productAlreadyExists = false
  newProduct: IProjectItem

  constructor(
    private projectService: ProjectService,
    private snackbarService: SnackbarService,
    private router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.init()
  }

  init() {
    this.productAlreadyExists = false
    this.selectedProduct = {
      product_id: this.productItem.id,
      quantity: 1,
    }
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith<string | IProject>(''),
      map((value) => (typeof value === 'string' ? value : value.name)),
      map((name) => (name ? this._filter(name) : this.options.slice(1)))
    )
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['projects'] && changes['projects'].currentValue) {
      this.options = [].concat(
        this.defaultItem,
        changes['projects'].currentValue
      )
    }
  }

  private _filter(name: string): IProject[] {
    this.options[0].name = name
    const filterValue = name.toLowerCase()
    return this.options.filter(
      (option) =>
        option.id === -1 || option.name.toLowerCase().indexOf(filterValue) === 0
    )
  }

  displayFn(project?: IProject): string | undefined {
    return ''
  }

  async selectOption(event: MatAutocompleteSelectedEvent) {
    try {
      let selectedProjectIndex
      let id = event.option.value.id
      if (id === -1) {
        id = (
          await this.projectService
            .createProject(event.option.value.name)
            .toPromise()
        ).projectId
      } else {
        selectedProjectIndex = this.options.findIndex(
          (project) => project.id === id
        )
        this.options[selectedProjectIndex].items.forEach((item) => {
          if (item.product_id === this.selectedProduct.product_id) {
            this.productAlreadyExists = true
            return
          }
        })
      }

      if (this.productAlreadyExists) {
        this.init()
        this.snackbarService.showSnackbar(
          'add_project.notification.already_exists',
          'error.button.close',
          'error-snack'
        )
      } else {
        await this.projectService
          .addProduct(id, this.selectedProduct)
          .toPromise()

        this.updateOpen(false)
        this.init()
        this.snackbarService.showSnackbar(
          'add_project.notification.added',
          'error.button.close',
          'success-snack'
        )
        this.router.navigate([this.translate.currentLang + '/projects'], {
          queryParams: { search: event.option.value.name },
        })
      }
    } catch (error) {
      this.snackbarService.showSnackbar(
        'error.server_error',
        'error.button.close',
        'error-snack'
      )
    }
  }

  updateOpen(value: boolean) {
    this.open = value
    this.openChange.emit(value)
  }
}
